import { PrefetchLink } from "@/components/routing/PrefetchLink";
import { Text } from "@mantine/core";
import styles from "../category/styles/CategoryTile.module.css";
import curated from "../curated/styles/Curated.module.css";
import { filterText, getPodcastImage, ImageSizes, truncate } from "@/core/helpers";
import { Urls } from "@/core/urls";

const SLOTS = [0, 1, 2, 3];

export const CollectionTile = ({ collection }: { collection: Collection }) => (
    <PrefetchLink className={styles.tile} to={Urls.collection(collection.slug)}>
        <div aria-hidden="true" className={styles.thumbs}>
            {SLOTS.map((i) => {
                const podcast = collection.podcasts[i];
                return podcast ? (
                    <img
                        alt=""
                        className={styles.thumb}
                        decoding="async"
                        height={ImageSizes.Small}
                        key={podcast.id}
                        loading="lazy"
                        src={getPodcastImage(podcast, ImageSizes.Small)}
                        width={ImageSizes.Small}
                    />
                ) : (
                    <span className={styles.thumbEmpty} key={i} />
                );
            })}
        </div>
        <div className={styles.body}>
            <Text className={styles.name} fw={700}>
                {collection.name}
            </Text>
            <Text c="dimmed" size="sm">
                {collection.podcasts.length} poddar
            </Text>
            {collection.content && (
                <Text c="dimmed" className={curated.excerpt} lineClamp={3} size="sm">
                    {truncate(filterText(collection.content), 160)}
                </Text>
            )}
            <span className={styles.cta}>Utforska →</span>
        </div>
    </PrefetchLink>
);
